import { string as yupString, number as yupNumber } from 'yup';
import { translate } from '../../locales/i18n';
import validation from '../../data/validation.json';

export const {
  GUIDE_NAME_MIN_LEN,
  GUIDE_DESC_MIN_LEN,
  TOUR_NAME_MIN_LEN,
  TOUR_DESC_MIN_LEN,
} = validation;

const langValidation = yupString()
  .min(2, (opts) => translate('validation_lang', opts))
  .max(2, (opts) => translate('validation_lang', opts))
  .required(() => translate('validation_lang'));

const guideNameValidation = yupString()
  .min(GUIDE_NAME_MIN_LEN, (opts) => translate('validation_guide_name_short', opts))
  // FIXME(clairbee): starts uppercase
  // FIXME(clairbee): not all caps
  .required(() => translate('validation_guide_name_required'));

const guideDescValidation = yupString()
  .min(GUIDE_DESC_MIN_LEN, (opts) => translate('validation_guide_about_short', opts))
  // FIXME(clairbee): starts uppercase
  // FIXME(clairbee): not all caps
  .required(() => translate('validation_guide_about_required'));

const appNameValidation = yupString()
  .min(TOUR_NAME_MIN_LEN, (opts) => translate('validation_app_name_short', opts))
  // FIXME(clairbee): starts uppercase
  // FIXME(clairbee): not all caps
  .required(() => translate('validation_app_name_required'));

const appDescValidation = yupString()
  .min(TOUR_DESC_MIN_LEN, (opts) => translate('validation_app_desc_short', opts))
  // FIXME(clairbee): starts uppercase
  // FIXME(clairbee): not all caps
  .required(() => translate('validation_app_desc_required'));

const appPriceValidation = yupNumber()
  .nullable()
  .moreThan(0.00999, (opts) => translate('validation_app_price_positive', opts));
// .required(() => translate('validation_app_price_required'));

const appRentDurationValidation = yupNumber()
  .nullable()
  .moreThan(6, (opts) => translate('validation_app_rent_duration_more', opts))
  .lessThan(366, (opts) => translate('validation_app_rent_duration_less', opts));
// .required(() => translate('validation_app_rent_duration_required'));

export {
  langValidation,
  appNameValidation,
  appDescValidation,
  guideNameValidation,
  guideDescValidation,
  appPriceValidation,
  appRentDurationValidation,
};
